module.exports = __webpack_public_path__ + "teqbahn-assets/media/24.2aa7bea9.jpg";